// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__1bq78","layoutContent":"Layout_layoutContent__LNA_3"};